const locale = {
  ERROR_TEXT:
    "Oops! It seems like you don't have the necessary permissions to access this page. Please contact your administrator or support for assistance.",
};

export default locale;
